import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Link from '../../../Utilities/Link'
import SampleButton from '../../../Utilities/SampleButton'
import RegionalMapShapefileContact from '../RegionalMapShapefileContact'
import { Container, H2, H4, Subtitle1, Body1, Share, Button, EmailOptin, CheckSubscription } from '../../../cdl-react-components/components'
import EditButton from '../../../Utilities/EditButton'
import ProgrammableLink from '../../../Utilities/ProgrammableLink'
import { DJANGO_URL } from '../../../cdl-react-components/utilities/constants'
import { formatBytes } from '../../../cdl-react-components/utilities/files'
import { formatResultsItemDate } from '../../../../utilities'

class RegionalMapDesktop extends Component {
    renderDownloadButton = (regionalMap, authenticated, user) => {
        if (!regionalMap.pdf)
            return null
        else if (new Date(regionalMap.publication_date) > new Date())
            return null
        else if (authenticated)
            return (
                <ProgrammableLink 
                    href={this.props.link}
                    target="_blank" rel="noreferrer"
                    onBeforeRedirect={this.props.logMapOpened}>
                    <Button raised style={{ width: '100%' }}>Download Map</Button>
                </ProgrammableLink>
            )
        else if (regionalMap.sample_pdf)
            return <SampleButton href={this.props.sampleLink} type="CDL Map">Download Sample Map</SampleButton>
        else if (user)
            return <Link className="btn btn--raised regional-map__read-article-btn" href="/subscribe">Subscribe to Download Map</Link>
        else
            return (
                // <div className="flex flex--end">
                //     <Link className="btn regional-map__read-article-btn" href="/subscribe">Subscribe</Link>
                    <Button className="regional-map__read-article-btn" raised onClick={this.props.handleLogin}>Login to View Map</Button>
                // </div>
            )
    }

    renderContents = regionalMap => {
        return (
            <div className="regional-map__contents">
                <H4>Contents</H4>
                <table>
                    <tbody>
                        <tr>
                            <th>Map&nbsp;type:</th>
                            <td>{regionalMap.map_type && regionalMap.map_type.map(x => x.name).join(', ')}</td>
                        </tr>
                        {regionalMap.pdf && (
                            <tr>
                                <th>File&nbsp;size:</th>
                                <td>{regionalMap.pdf_size_field ? formatBytes(regionalMap.pdf_size_field, 2) : null}</td>
                            </tr>
                        )}                      
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        const { regionalMap, authenticated, user } = this.props

        const description = authenticated ?
            regionalMap.private_description :
            regionalMap.description

        return (
            <Container id="regional-map--desktop" className="content-layout--two-column">
                <div>
                    <div className="regional-map__image">
                        <img alt={regionalMap.title} src={this.props.getImage(regionalMap, authenticated)} />
                    </div>
                    { authenticated ? 
                        (<Fragment>
                            {this.renderDownloadButton(regionalMap, authenticated, user)}
                            <RegionalMapShapefileContact map={regionalMap} />
                            {this.renderContents(regionalMap)}
                            <hr />
                            <EmailOptin
                                message="Sign up to receive weekly email alerts from Canadian Discovery when there are new Discovery Digest articles, features or events"
                                successMessage="Sign-up Successful"
                                role="Mail-9-Articles" />
                        </Fragment>) :
                        (<Fragment>
                            {this.renderContents(regionalMap)}
                            {this.renderDownloadButton(regionalMap, authenticated, user)}
                            <RegionalMapShapefileContact map={regionalMap} />
                            <hr />
                            <CheckSubscription
                                message="A subscription to the Discovery Digest is required to view this content. Enter your email below to find out if your company subscribes."
                                productName="Canadian Discovery's Discovery Digest"
                                shortProductName="the Discovery Digest"
                                role="CDD" />
                        </Fragment>)
                    }
                </div>
                <div>
                    <H2>{regionalMap.title} {<EditButton href={`${DJANGO_URL}/admin/content/regionalmap/${regionalMap.id}/change/`} />}</H2>
                    <Subtitle1>{regionalMap.subtitle}</Subtitle1>
                    <Body1>{formatResultsItemDate(regionalMap)}</Body1>
                    <Body1 dangerouslySetInnerHTML={{ __html: description }} />
                    <hr />                    
                    <div className="flex flex--end">
                        <Share title={regionalMap.title} url={window.location.origin + window.location.pathname} />
                    </div>
                </div>
            </Container>
        )
    }
}

RegionalMapDesktop.propTypes = {
    regionalMap: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    logMapOpened: PropTypes.func.isRequired,
    user: PropTypes.object,
    link: PropTypes.string,
    sampleLink: PropTypes.string
}

export default RegionalMapDesktop